import { render, staticRenderFns } from "./TextCopyButton.vue?vue&type=template&id=24e6ea30&"
import script from "./TextCopyButton.vue?vue&type=script&lang=ts&"
export * from "./TextCopyButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports